import {
    WORKSPACE_URI,
    DISCOVERY_URI,
    INSIGHTS_URI,
    CHEMICAL_URI,
    BIO_URI,
    HOME_URI,
    LAB_URI,
} from 'library-@/config/apiConfig';

export const SET_ENABLE = 'SET_ENABLE';
export const SET_TEXT = 'SET_TEXT';
export const KEY_LIFESCIENCE_ENABLE = 'KEY_LIFESCIENCE_ENABLE';
export const LIFESCIENCE_ENABLE = '1';
export const LIFESCIENCE_DISABLE = '0';

export const SECTION_TITLE = 'TITLE';
export const SECTION_CLAIM = 'CLMS';
export const SECTION_ABSTRACT = 'ABST';
export const SECTION_DESCRIPTION = 'DESC';
export const SECTION_TECHNICAL_PROBLEM = 'AI_TECHNICAL_PROBLEM';
export const SECTION_EFFICIENCY_SENTENCE = 'AI_TECHNICAL_BENEFIT';

export const SECTIONS_ALL = [SECTION_TITLE, SECTION_CLAIM, SECTION_ABSTRACT, SECTION_DESCRIPTION, SECTION_TECHNICAL_PROBLEM, SECTION_EFFICIENCY_SENTENCE];

export const HTTP_METHOD_POST = 'post';
export const CONTENT_TYPE_FORM = 'application/x-www-form-urlencoded';

export const LIMIT_LENGTH_TRANSLATE_PACK = 1900;
export const LIMIT_TRANSLATE_RETRY = 3;
export const BACK_SLASH_N = '\n';
export const BACK_DOUBLE_SLASH_N = '\\n';
export const SEPARATOR_REGEXP = new RegExp('<br/>|\\\\n', 'g');
export const SPLIT_SYMBOL_REGEXP = new RegExp('[,，.。?？:：;；、!！~]');
export const GOOGLE_PARAGRAPH_MARK_SYMBOL = '------';
export const PARAGRAPH_MARK_SYMBOL = '\r\n';

export const CLASS_NAME_HIDE_SEQUENCE = 'hide-sequences';
export const CLASS_NAME_SHOW_SEQUENCE = 'show-sequences';
export const SELECTOR_SHOW_SEQUENCE = `.${CLASS_NAME_SHOW_SEQUENCE}`;

export const CLASS_NAME_APP_CONTENT = 'patent-app__content';
export const SELECTOR_APP_CONTENT = `.${CLASS_NAME_APP_CONTENT}`;

export const CLASS_NAME_APP_CONTENT_VIEW = 'patent-app__content-view';
export const SELECTOR_APP_CONTENT_VIEW = `.${CLASS_NAME_APP_CONTENT_VIEW}`;

export const CLASS_NAME_BIO_POPOVER = 'bio-popper';
export const SELECTOR_BIO_POPOVER = `.${CLASS_NAME_BIO_POPOVER}`;

export const CLASS_NAME_BIO_POPOVER_SIMILARITY = 'bio-similarity-popover';
export const SELECTOR_BIO_POPOVER_SIMILARITY = `.${CLASS_NAME_BIO_POPOVER_SIMILARITY}`;

export const CLASS_NAME_BIO_CODE = 'bio-panel-item__code';
export const SELECTOR_BIO_CODE = `.${CLASS_NAME_BIO_CODE}`;

export const CLASS_NAME_HIDE_STRUCTURE = 'hide-structures';
export const CLASS_NAME_HIDE_OTHERS_STRUCTURE = 'hide-other-structures';

export const ROUTE_NAME_ROOT = 'Root';
export const ROUTE_NAME_OVERVIEW = 'Overview';
export const ROUTE_NAME_ABST = 'Abst';
export const ROUTE_NAME_CITATION = 'Citation';
export const ROUTE_NAME_CITATION_PATENT = 'CitationPatent';
export const ROUTE_NAME_CITATION_NO_PATENT = 'CitationNoPatent';
export const ROUTE_NAME_CLMS = 'Clms';
export const ROUTE_NAME_DESC = 'Desc';
export const ROUTE_NAME_DUAL = 'Dual';
export const ROUTE_NAME_SUBDUAL = 'subDual';
export const ROUTE_NAME_COMPARE = 'compare';
export const ROUTE_NAME_THUMB = 'Thumb';
export const ROUTE_NAME_SIMILAR = 'Similar';
export const ROUTE_NAME_VALUATION = 'Valuation';
export const ROUTE_NAME_LEGAL = 'Legal';
export const ROUTE_NAME_LEGAL_STATUS = 'LegalStatus';
export const ROUTE_NAME_LITIGATION = 'Litigation';
export const ROUTE_NAME_REREXAM = 'Rerexam';
export const ROUTE_NAME_LICENSING = 'Licensing';
export const ROUTE_NAME_PLEDGE = 'Pledge';
export const ROUTE_NAME_FILE_WRAPPER = 'FileWrapper';
export const ROUTE_NAME_CUSTOMS = 'Customs';
export const ROUTE_NAME_PATENT_FAMILY = 'patentFamily';
export const ROUTE_NAME_CLAIM_CHARTING = 'claimCharting';
export const VIEW_ROUTE_CACHE_KEY = 'VIEW_ROUTE_CACHE_KEY';


export const ROUTES_ENABLE_BIO = ['abst', 'clms', 'desc'];
export const ROUTES_ENABLE_CHEMICAL = ['abst', 'clms', 'desc'];

export const ROUTES_DISABLE_HIGHLIGHT = [
    ROUTE_NAME_CITATION,
    ROUTE_NAME_CITATION_PATENT,
    ROUTE_NAME_CITATION_NO_PATENT,
    ROUTE_NAME_PATENT_FAMILY,
    ROUTE_NAME_LEGAL_STATUS,
    ROUTE_NAME_LITIGATION,
    ROUTE_NAME_REREXAM,
    ROUTE_NAME_LICENSING,
    ROUTE_NAME_PLEDGE,
    ROUTE_NAME_FILE_WRAPPER,
    ROUTE_NAME_CUSTOMS,
];

export const MAXIMUM_LIST_INDEX_NUM = 20000;
export const IE9 = /MSIE 9/i.test(navigator.userAgent);
export const IE10 = /MSIE 10/i.test(navigator.userAgent);
export const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
export const isIE = 'onmspointerleave' in window || IE9 || IE10;
export const isSafari = /Safari/i.test(navigator.userAgent) && !/Chrome/i.test(navigator.userAgent);

const winNav = window.navigator;
export const isWin = (winNav.platform || '').indexOf('Win') >= 0;
const isChromium = window.chrome;
export const isIEedge = winNav.userAgent.indexOf('Edge') > -1;
export const isWinChrome = isWin && isChromium && !isIEedge;

// 当本身的引用或被引用数量超过1000时，不支持查看同族引用/被引用 （同族禁用状态）
export const MAX_LIMIT_THEN_NOT_SUPPORT_VIEW_FAMILY_CITATION = 1000;

// 最大注释长度
export const MAX_LIMIT_COMMENT_TEXT_LENGTH = 1000;

export const MAX_LIMIT_COMMENT_LENGTH = 99;

// popper open-delay
export const POPPER_OPEN_DELAY = 300;

// bio最大下载长度
export const MAX_LIMIT_SEQUENCE_DOWNLOAD = 50000;

// 最大可以添加到bio 提取数量
export const MAX_LIMIT_SEQUENCE_EXTRACT = 50000;

// 最大可以添加到bio msa中的序列数量
export const MAX_TO_MSA_COUNT = 100;

// 最大可以查询到的结果页面
export const MAX_TO_BIO_SEARCH_RESULT = 50000;

export const ADD_TO_MSA_ERROR_TYPE = {
    'ERROR_TYPE': 'errorType',
    'ERROR_LENGTH': 'errorLength',
    'ERROR_NOT_FOUND': 'errorNotFound',
};

// 添加到msa的最大序列长度
export const MAX_PROTEIN = 50000;
export const MAX_NUCLEOTIDE = 50000;
// 选中序列会有几千个，用分页，处理加载慢的问题，单页数量
export const SEQUENCE_PAGE_SIZE = 100;

// comment的owner相关权限
export const COMMENT_OWNER_PERMISSION = {
    'STRANGER': false,
    'OWNER': true,
};

// 从 workspace srp patentview 将三方同步
export const NAMESPACE_PATENT_VIEW = 'pv';

// 划段缓存key
export const HIGHLIGHT_CACHE_KEY_IN_ABST = 'HIGHLIGHT_CACHE_KEY_IN_ABST';
export const HIGHLIGHT_CACHE_KEY_IN_CLMS = 'HIGHLIGHT_CACHE_KEY_IN_CLMS';
export const HIGHLIGHT_CACHE_KEY_IN_DESC = 'HIGHLIGHT_CACHE_KEY_IN_DESC';
export const HIGHLIGHT_CACHE_KEY_IN_ABST_TRANS = 'HIGHLIGHT_CACHE_KEY_IN_ABST_TRANS';
export const HIGHLIGHT_CACHE_KEY_IN_CLMS_TRANS = 'HIGHLIGHT_CACHE_KEY_IN_CLMS_TRANS';
export const HIGHLIGHT_CACHE_KEY_IN_DESC_TRANS = 'HIGHLIGHT_CACHE_KEY_IN_DESC_TRANS';

export const SEMANTIC_SUPPORTED_LANG = ['CN', 'EN'];

export const CLASS_NAME_BIO_HL = 'bio-hl';
export const SELECTOR_BIO_HL = `.${CLASS_NAME_BIO_HL}`;
/**
 * TOC-21933 Add max seq no
 */
export const MAX_SEQ_NO = 20000;
export const MAX_AUTOCOMPLETE_SEQ_NO = 200;

export const EVENT_MOUSEENTER = 'mouseenter';
export const EVENT_MOUSELEAVE = 'mouseleave';
export const EVENT_MOUSECLICK = 'click';

export const POPPER_OPTIONS = {
    placement: 'bottom-start',
    modifiers: {
        flip: {
            behavior: ['bottom', 'top'],
        },
        offset: {
            offset: '0, 8',
        },
    },
    eventsEnabled: false,
};

// 选择AIpatent时root/lang设置的值的集合
export const AIPATENT_INCLUDE = ['AIJP', 'AIEN', 'AICN'];

// 同族对比组件中service ，用来区分对比内容以及其对应i18n
export const CLMS_COMPARE_SERVICE = 'CLMS_COMPARE';
export const DESC_COMPARE_SERVICE = 'DESC_COMPARE';

// 对比数组数据换行连接符
export const LINK_BREAK = `
`;
// 对比超长本文最大限制
export const MAX_WORD_NUM = 200000;

export const FE_WORKSPACE_URI = WORKSPACE_URI;
export const FE_DISCOVERY_URI = DISCOVERY_URI;
export const FE_INSIGHTS_URI = INSIGHTS_URI;
export const FE_CHEMICAL_URI = CHEMICAL_URI;
export const FE_BIO_URI = BIO_URI;
export const FE_HOME_URI = HOME_URI;
export const FE_LAB_URI = LAB_URI;

export const BIO_SEARCH_TYPE = {
    cdr: 'CDR',
    // 从analytics返回
    analytics: 'ANALYTICS',
    motif: 'MOTIF',
    motif2: 'MOTIF2',
    fragmentSize: 'FRAGMENT_SIZE',
    fragmentMulti: 'FRAGMENT_MULTI',
    sequence: 'MANUAL',
    short: 'SHORT',
    antibody: 'ANTIBODY',
    combined: 'COMBINED',
    degenerate: 'DEGENERATE',
    modification: 'MODIFICATION',
};

export const ABST_PROTEIN = 'PROTEIN';
export const ABST_NUC = 'NUCLEOTIDE';

export const SEQUENCE_TYPE = {
    protein: {
        value: 'PROTEIN',
        title: 'Protein',
        suffix: 'aa',
        i18nKey: 'globals.protein',
    },
    nucleotide: {
        value: 'NUCLEOTIDE',
        title: 'Nucleotide',
        suffix: 'nt',
        i18nKey: 'globals.nucleotide',
    },
};

export const COMPARE_STANDARD_SCORE = 80;

export const PATENT_SELECT_LIMIT = 100;

export const CITATION_SEARCH_COUNT_LIMIT = 500;

export const SMART_FIGURES_TOGGLE_STATUS = 'SmartFiguresToggleStatus';

export const TEXT_IMAGE_FEATURE_TOGGLE = 'TextImageFeatureToggle';

export const SIDE_IDENTIFIER = 'both';

export const SIDE_LEFT = 'left';
